import { combineReducers } from '@reduxjs/toolkit'

import { NameSpace } from '@/store/nameSpace'
import app from '@/store/slices/app'

export default combineReducers({
  [NameSpace.APP]: app,
})
